import Vue from 'vue';
import Router from 'vue-router';
import AuthLayout from '@/layouts/Auth';
import PublicLayout from '@/layouts/Public';
import AppLayout from '@/layouts/App';
import store from '@/store';
import { get, includes, startsWith, isEmpty, isArray } from 'lodash';

Vue.use(Router);
const routes = [
  // Admin page
  {
    path: '/:locale?/admin',
    component: AppLayout,
    meta: {
      isAdmin: true,
      authRequired: true,
      isParent: true,
      hidden: true,
    },
    children: [
      // Dashboards
      {
        path: '',
        meta: {
          title: 'Admin Dashboard',
        },
        name: 'AdminDashboard',
        component: () => import('./views/admin/Dashboard'),
      },
      // {
      //   path: 'settings',
      //   meta: {
      //     title: 'Settings',
      //   },
      //   name: 'adminSettings',
      //   component: () => import('./views/admin/Settings'),
      // },
      {
        path: 'settings',
        meta: {
          title: 'Settings',
        },
        name: 'adminSettings2',
        component: () => import('./views/admin/settings2'),
      },
      {
        path: 'account',
        meta: {
          title: 'Admin Account',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Admin Account',
            },
            name: 'AdminAccount',
            component: () => import('./views/admin/account/list'),
          },
          {
            path: 'create',
            meta: {
              title: 'Admin Create Account',
              payRequired: false,
            },
            name: 'AdminAccountCreate',
            component: () => import('./views/admin/account/create'),
          },
          {
            path: ':account_id',
            meta: {
              title: 'Admin Account Detail',
            },
            name: 'AdminAccountDetail',
            component: () => import('./views/admin/account/detail'),
          },
        ],
      },
      {
        path: 'cardOrder',
        meta: {
          title: 'Admin Card Order',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Admin Card Order',
            },
            name: 'AdminCardOrders',
            component: () => import('./views/admin/cardOrder/orders'),
          },
          {
            path: 'new',
            meta: {
              title: 'Admin Card Order New',
            },
            name: 'AdminCardOrderNew',
            component: () => import('./views/admin/cardOrder/orders'),
          },
          {
            path: 'history',
            meta: {
              title: 'Admin Card Order History',
            },
            name: 'AdminCardOrderHistory',
            component: () => import('./views/admin/cardOrder/orders'),
          },
        ],
      },
      {
        path: 'share-story',
        meta: {
          title: 'Admin Share Story',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Admin Share Story',
            },
            name: 'AdminShareStory',
            component: () => import('./views/admin/shareStory/list'),
          },
        ],
      },
      {
        path: 'user',
        meta: {
          title: 'Admin User',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Admin User',
            },
            name: 'AdminUser',
            component: () => import('./views/admin/user/list'),
          },
        ],
      },
      {
        path: 'free_user',
        meta: {
          title: 'Admin Free User',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Admin Free User',
            },
            name: 'AdminFreeUser',
            component: () => import('./views/admin/user/free_users'),
          },
        ],
      },
      {
        path: 'paster_signup',
        meta: {
          title: 'paster sign up',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Paster Sign up',
            },
            name: 'PasterSignup',
            component: () => import('./views/admin/user/pasters'),
          },
        ],
      },
      {
        path: 'qr_code',
        meta: {
          title: 'Admin QR Code',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Admin QR Code',
            },
            name: 'AdminQRCode',
            component: () => import('./views/admin/user/qr_code'),
          },
        ],
      },
      {
        path: 'moderators',
        meta: {
          title: 'Moderators',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Moderators',
            },
            name: 'AdminModerators',
            component: () => import('./views/admin/moderators/list'),
          },
        ],
      },
      {
        path: 'moderator-activities',
        meta: {
          title: 'Moderator Activities',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Moderator Activities',
            },
            name: 'AdminModeratorActivities',
            component: () => import('./views/admin/moderator_activities/list'),
          },
        ],
      },
      {
        path: 'videos',
        meta: {
          title: 'Videos',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Videos',
            },
            name: 'AdminVideos',
            component: () => import('./views/admin/videos/list'),
          },
        ],
      },
      {
        path: 'videoUpload',
        meta: {
          title: 'Upload Video',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Upload Video',
            },
            name: 'AdminVideoUpload',
            component: () => import('./views/admin/videoUpload'),
          },
        ],
      },
      {
        path: 'video-review',
        meta: {
          title: 'Video Review',
        },
        name: 'adminVideoReview',
        component: () => import('./views/videoReview'),
      },
      {
        path: 'ai_control',
        meta: {
          title: 'Ai Control Page',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Ai Control Page',
            },
            name: 'AiControlPage',
            component: () => import('./views/admin/ai_control/form'),
          },
        ],
      },
      {
        path: 'pages',
        meta: {
          title: 'Admin Pages',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Admin Pages',
            },
            name: 'AdminPages',
            component: () => import('./views/admin/pages/list'),
          },

          {
            path: 'create',
            meta: {
              title: 'Admin Create Page',
            },
            name: 'AdminCreatePage',
            component: () => import('./views/admin/pages/detail'),
          },
          {
            path: 'detail/:pageSlug',
            meta: {
              title: 'Admin Page Detail',
            },
            name: 'AdminPageDetail',
            component: () => import('./views/admin/pages/detail'),
          },
        ],
      },
      {
        path: 'monthly_pages',
        meta: {
          title: 'Admin Monthly Pages',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Admin Monthly Pages',
            },
            name: 'AdminMonthlyPages',
            component: () => import('./views/admin/monthly_pages/list'),
          },

          {
            path: 'create',
            meta: {
              title: 'Admin Create Monthly Page',
            },
            name: 'AdminCreateMonthlyPage',
            component: () => import('./views/admin/monthly_pages/detail'),
          },
          {
            path: 'detail/:pageSlug',
            meta: {
              title: 'Admin Monthly Page Detail',
            },
            name: 'AdminMonthlyPageDetail',
            component: () => import('./views/admin/monthly_pages/detail'),
          },
        ],
      },
      {
        path: 'post',
        meta: {
          title: 'Admin Post',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Admin Post',
            },
            name: 'AdminPost',
            component: () => import('./views/admin/post/list'),
          },

          {
            path: 'create',
            meta: {
              title: 'Admin Create Post',
            },
            name: 'AdminCreatePost',
            component: () => import('./views/admin/post/detail'),
          },
          {
            path: 'detail/:postSlug',
            meta: {
              title: 'Admin Post Detail',
            },
            name: 'AdminPostDetail',
            component: () => import('./views/admin/post/detail'),
          },
        ],
      },
      {
        path: 'care_video',
        meta: {
          title: 'Admin Care Video',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Admin Care Video',
            },
            name: 'AdminCareVideo',
            component: () => import('./views/admin/care_video/list'),
          },

          {
            path: 'create',
            meta: {
              title: 'Admin Create Care Video',
            },
            name: 'AdminCreateCareVideo',
            component: () => import('./views/admin/care_video/detail'),
          },
          {
            path: 'detail/:careVideoSlug',
            meta: {
              title: 'Admin Care Video Detail',
            },
            name: 'AdminCareVideoDetail',
            component: () => import('./views/admin/care_video/detail'),
          },
        ],
      },
      {
        path: 'care_category',
        meta: {
          title: 'Admin Care Category',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Admin Care Category',
            },
            name: 'AdminCareCategory',
            component: () => import('./views/admin/care_category/list'),
          },

          {
            path: 'create',
            meta: {
              title: 'Admin Create Care Category',
            },
            name: 'AdminCreateCareCategory',
            component: () => import('./views/admin/care_category/detail'),
          },
          {
            path: 'detail/:careCategorySlug',
            meta: {
              title: 'Admin Care Category Detail',
            },
            name: 'AdminCareCategoryDetail',
            component: () => import('./views/admin/care_category/detail'),
          },
        ],
      },
      {
        path: 'care_speaker_bio',
        meta: {
          title: 'Admin Care Speaker Bio',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Admin Care Speaker Bio',
            },
            name: 'AdminCareSpeakerBio',
            component: () => import('./views/admin/care_speaker_bio/list'),
          },

          {
            path: 'create',
            meta: {
              title: 'Admin Create Care Speaker Bio',
            },
            name: 'AdminCreateCareSpeakerBio',
            component: () => import('./views/admin/care_speaker_bio/detail'),
          },
          {
            path: 'detail/:careSpeakerBioSlug',
            meta: {
              title: 'Admin Care Speaker Bio Detail',
            },
            name: 'AdminCareSpeakerBioDetail',
            component: () => import('./views/admin/care_speaker_bio/detail'),
          },
        ],
      },
      {
        path: 'location',
        meta: {
          title: 'Admin Location',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Admin Location',
            },
            name: 'AdminLocation',
            component: () => import('./views/admin/location/list'),
          },
        ],
      },
      {
        path: 'category',
        meta: {
          title: 'Admin Category',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: '',
            meta: {
              title: 'Admin Category',
            },
            name: 'AdminCategory',
            component: () => import('./views/admin/category/list'),
          },
          {
            path: 'create',
            meta: {
              title: 'Admin Create Category',
            },
            name: 'AdminCreateCategory',
            component: () => import('./views/admin/category/detail'),
          },
          {
            path: 'detail/:categorySlug',
            meta: {
              title: 'Admin Category Detail',
            },
            name: 'AdminCategoryDetail',
            component: () => import('./views/admin/category/detail'),
          },
          {
            path: 'detail/:categorySlug/answer/create',
            meta: {
              title: 'Admin Create Answer',
            },
            name: 'AdminCreateCategoryAnswer',
            component: () => import('./views/admin/answer/detail'),
          },
          {
            path: 'detail/:categorySlug/answer/:answerSlug',
            meta: {
              title: 'Admin Answer Detail',
            },
            name: 'AdminCategoryAnswerDetail',
            component: () => import('./views/admin/answer/detail'),
          },
          {
            path: 'detail/:categorySlug/testimonial/create',
            meta: {
              title: 'Admin Create Testimonial',
            },
            name: 'AdminCreateCategoryTestimonial',
            component: () => import('./views/admin/testimonial/detail'),
          },
          {
            path: 'detail/:categorySlug/testimonial/:testimonialSlug',
            meta: {
              title: 'Admin Testimonial Detail',
            },
            name: 'AdminCategoryTestimonialDetail',
            component: () => import('./views/admin/testimonial/detail'),
          },
        ],
      },
      {
        path: 'store',
        meta: {
          title: 'Store Admin',
        },
        component: () => import('./views/admin'),
        children: [
          {
            path: 'products',
            meta: {
              title: 'Admin Products',
            },
            name: 'AdminProducts',
            component: () => import('./views/admin/store/products/list'),
          },
          {
            path: 'products/:id',
            meta: {
              title: 'Admin Product Detail',
            },
            name: 'AdminProductDetail',
            component: () => import('./views/admin/store/products/detail'),
          },
          {
            path: 'categories',
            meta: {
              title: 'Admin Product Categories',
            },
            name: 'AdminProductCategories',
            component: () => import('./views/admin/store/categories/list'),
          },
          {
            path: 'categories/:id',
            meta: {
              title: 'Admin Product Category Detail',
            },
            name: 'AdminProductCategoryDetail',
            component: () => import('./views/admin/store/categories/detail'),
          },
        ],
      },
    ],
  },

  {
    path: '/:locale?',
    redirect: 'dashboard',
    component: AppLayout,
    meta: {
      authRequired: true,
      hidden: true,
      payRequired: true,
      isParent: true,
    },
    children: [
      // Dashboards
      {
        path: 'dashboard',
        meta: {
          title: 'Dashboard',
          payRequired: false,
        },
        name: 'dashboard',
        component: () => import('./views/dashboard'),
      },
      {
        path: 'care-dashboard',
        meta: {
          title: 'Dashboard',
          payRequired: false,
        },
        name: 'careDashboard',
        component: () => import('./views/careDashboard'),
      },
      {
        path: 'individual-dashboard',
        meta: {
          title: 'Dashboard',
          payRequired: false,
        },
        name: 'individualDashboard',
        component: () => import('./views/individualDashboard'),
      },
      {
        path: 'account',
        meta: {
          title: 'Account',
          payRequired: false,
        },
        name: 'account',
        component: () => import('./views/account'),
      },

      {
        path: 'updateInfo',
        meta: {
          title: 'Update User Info',
        },
        name: 'updateUserInfo',
        component: () => import('./views/users/updateInfo'),
      },
      {
        path: 'inbox',
        meta: {
          title: 'Inbox',
        },
        name: 'inbox',
        component: () => import('./views/messages'),
      },
      {
        path: 'masseage/:id',
        meta: {
          title: 'Messages',
          hidden: true,
        },
        name: 'message',
        component: () => import('./views/messages/messageDetail'),
      },
      // {
      //   path: 'track-progress',
      //   meta: {
      //     title: 'Track Your Progress',
      //   },
      //   name: 'trackProgress',
      //   component: () => import('./views/trackProgress'),
      // },
      {
        path: 'campuses',
        meta: {
          title: 'Campuses',
        },
        name: 'campuses',
        component: () => import('./views/campuses'),
      },
      {
        path: 'capture',
        meta: {
          title: 'Capture',
        },
        name: 'captureVideo',
        component: () => import('./views/capture'),
      },
      {
        path: 'testimonials',
        meta: {
          title: 'Testimonials',
        },
        name: 'testimonials',
        component: () => import('./views/testimonials'),
      },
      {
        path: 'get-results',
        meta: {
          title: 'Get Result',
        },
        name: 'getResults',
        component: () => import('./views/getResults'),
      },
      {
        path: 'subscriptions',
        meta: {
          title: 'Subscriptions',
        },
        name: 'subscriptions',
        component: () => import('./views/subscriptions'),
      },
      {
        path: 'churchAccess',
        meta: {
          title: 'Church Access',
        },
        name: 'churchAccess',
        component: () => import('./views/churchAccess'),
      },
      {
        path: 'churchProfile',
        meta: {
          title: 'Church Profile',
        },
        name: 'churchProfile',
        component: () => import('./views/churchProfile'),
      },
      {
        path: 'editProfile',
        meta: {
          title: 'Edit Profile',
        },
        name: 'editProfile',
        component: () => import('./views/profile/editProfile'),
      },
      {
        path: 'profileVideo',
        meta: {
          title: 'Profile Video',
        },
        name: 'profileVideo',
        component: () => import('./views/profile/video'),
      },
      {
        path: 'studyGuides',
        meta: {
          title: 'Study Guides',
        },
        name: 'studyGuides',
        component: () => import('./views/studyGuide'),
      },
      {
        path: 'bulletinInserts',
        meta: {
          title: 'Bulletin Inserts',
        },
        name: 'bulletinInserts',
        component: () => import('./views/bulletinInserts'),
      },
      {
        path: 'bulletinInsertsCare',
        meta: {
          title: 'Bulletin Inserts',
        },
        name: 'bulletinInsertsCare',
        component: () => import('./views/bulletinInserts/care'),
      },
      {
        path: 'resources',
        meta: {
          title: 'Resources',
        },
        name: 'resources',
        component: () => import('./views/resources'),
      },
      {
        path: 'videoPlayer',
        meta: {
          title: 'Video Player',
        },
        name: 'videoPlayer',
        component: () => import('./views/videoPlayer'),
      },
      {
        path: 'careVideoPlayer',
        meta: {
          title: 'Care Video Player',
        },
        name: 'careVideoPlayer',
        component: () => import('./views/careVideoPlayer'),
      },
      {
        path: 'monthlyVideos',
        meta: {
          title: 'Monthly Videos',
        },
        name: 'monthlyVideos',
        component: () => import('./views/monthlyVideos'),
      },
      {
        path: 'individual/orderCards',
        meta: {
          title: 'Individual Order Cards',
        },
        name: 'individualOrderCards',
        component: () => import('./views/individualOrderCards'),
      },
      {
        path: 'orderCards',
        meta: {
          title: 'Order Cards',
        },
        name: 'orderCards',
        component: () => import('./views/orderCards'),
      },
      {
        path: 'reOrderCards',
        meta: {
          title: 'Re Ordering Cards',
          hidden: true,
        },
        name: 'reOrderCards',
        component: () => import('./views/reOrderCards'),
      },
      {
        path: 'orderProducts',
        meta: {
          title: 'Order Products',
        },
        name: 'orderProducts',
        component: () => import('./views/orderProducts'),
      },
      {
        path: 'orderProducts/:categoryId',
        meta: {
          title: 'Order Products',
        },
        name: 'orderProductsDetail',
        component: () => import('./views/orderProducts/detail'),
      },
      {
        path: 'orderProducts/:id/checkout',
        meta: {
          title: 'Checkout',
        },
        name: 'orderProductsCheckout',
        component: () => import('./views/orderProducts/checkout'),
      },
      // {
      //   path: 'support',
      //   meta: {
      //     title: 'Get Support',
      //     payRequired: false,
      //   },
      //   name: 'support',
      //   component: () => import('./views/support'),
      // },
      {
        path: 'specialOffers',
        meta: {
          title: 'Special Offers',
        },
        name: 'specialOffers',
        component: () => import('./views/specialOffers'),
      },
      {
        path: 'updateBillingInfo',
        meta: {
          title: 'Payment Information',
          payRequired: false,
        },
        name: 'updateBillingInfo',
        component: () => import('./views/updateBillingInfo'),
      },
      {
        path: 'paymentInfo',
        meta: {
          title: 'Payment Information',
          payRequired: false,
        },
        name: 'paymentInfo',
        component: () => import('./views/paymentInformation'),
      },
      {
        path: 'donate',
        meta: {
          title: 'Donate',
          payRequired: false,
        },
        name: 'donate',
        component: () => import('./views/donate'),
      },
      {
        path: 'plan',
        meta: {
          title: 'Plan',
          payRequired: false,
        },
        name: 'plan',
        component: () => import('./views/plan'),
      },
      {
        path: 'share-your-story',
        meta: {
          title: 'Share My Jesus Story',
          showProgressBar: false,
        },
        name: 'shareYourStory',
        component: () => import('./views/newShareStory'),
      },
      {
        path: 'evangelism-bootcamp',
        meta: {
          title: 'Evangelism Boot Camp',
        },
        name: 'evangelismBootcamp',
        component: () => import('./views/evangelismBootcamp'),
      },
      {
        path: 'welcome-video',
        meta: {
          title: 'Welcome Video',
        },
        name: 'welcomeVideo',
        component: () => import('./views/newWelcomeVideo'),
      },
      {
        path: 'become-moderator',
        meta: {
          title: 'Become a Moderator',
        },
        name: 'becomeModerator',
        component: () => import('./views/becomeModerator'),
      },
      {
        path: 'invite-moderator',
        meta: {
          title: 'Invite Moderators',
        },
        name: 'churchInviteModerator',
        component: () => import('./views/churchInviteModerator'),
      },
      {
        path: 'church-moderators',
        meta: {
          title: 'Church Moderators',
        },
        name: 'churchModerators',
        component: () => import('./views/churchModerators'),
      },
      {
        path: 'video-review',
        meta: {
          title: 'Video Review',
        },
        name: 'videoReview',
        component: () => import('./views/videoReview'),
      },
      {
        path: 'setup-share-story',
        meta: {
          title: 'Set Up Share Your Story',
        },
        name: 'setupShareStory',
        component: () => import('./views/churchSetupShareStory'),
      },
      {
        path: 'connect-request',
        meta: {
          title: 'Connections',
        },
        name: 'connectRequest',
        component: () => import('./views/churchConnectRequest'),
      },
      {
        path: 'upgrade-information',
        meta: {
          title: 'Upgrade',
        },
        name: 'upgradeInformation',
        component: () => import('./views/upgradeInformation'),
      },
      {
        path: 'upgrade-membership',
        meta: {
          title: 'Upgrade',
        },
        name: 'upgradeMembership',
        component: () => import('./views/upgradeMembership'),
      },
      {
        path: 'upgrade-successfull',
        meta: {
          title: 'Upgrade',
        },
        name: 'upgradeSuccessfull',
        component: () => import('./views/upgradeSuccessfull'),
      },
      {
        path: 'connect-to-church',
        meta: {
          title: 'Connect to church',
        },
        name: 'connectToChurch',
        component: () => import('./views/individualConnectChurch'),
      },
      {
        path: 'jesus-stories',
        meta: {
          title: 'Jesus Stories',
        },
        name: 'jesusStories',
        component: () => import('./views/jesusStories'),
      },
      // 404
      {
        path: '404',
        name: '404',
        meta: {
          title: 'Error 404',
          payRequired: false,
        },
        component: () => import('./views/system/404'),
      },
    ],
  },

  // System Pages
  {
    path: '/:locale?/users',
    component: AuthLayout,
    meta: {
      isSystemPage: true,
    },
    children: [
      {
        path: 'sign-in',
        name: 'signIn',
        meta: {
          title: 'Sign In',
        },
        component: () => import('./views/users/login'),
      },
      {
        path: 'forgot-password',
        name: 'forgotPassword',
        meta: {
          title: 'Forgot Password',
        },
        component: () => import('./views/users/forgot-password'),
      },
      {
        path: 'reset-password',
        name: 'resetPassword',
        meta: {
          title: 'Reset Password',
        },
        component: () => import('./views/users/reset-password'),
      },
      {
        path: 'system/404',
        name: 'system404',
        meta: {
          title: 'Error 404',
        },
        component: () => import('./views/system/404'),
      },
      {
        path: '/system/500',
        name: 'system500',
        meta: {
          title: 'Error 500',
        },
        component: () => import('./views/system/500'),
      },
      // 404
      {
        path: '/system/coming',
        name: 'ComingSoon',
        meta: {
          title: 'Coming Soon',
        },
        component: () => import('./views/system/503'),
      },
    ],
  },

  // Checkout page
  // System Pages
  {
    path: '/:locale?/individual/checkout',
    component: PublicLayout,
    children: [
      {
        path: '',
        name: 'individualCheckout',
        meta: {
          title: 'Individual Check out',
        },
        component: () => import('./views/individualCheckout'),
      },
    ],
  },
  {
    path: '/:locale?/checkout',
    component: PublicLayout,
    children: [
      {
        path: '',
        name: 'checkout',
        meta: {
          title: 'Check out',
        },
        component: () => import('./views/checkout'),
      },
    ],
  },

  {
    path: '/:locale?/donation',
    component: PublicLayout,
    children: [
      {
        path: '',
        name: 'donation',
        meta: {
          title: 'Donation',
        },
        component: () => import('./views/donation'),
      },
    ],
  },
  {
    path: '/:locale?/billing-renewal',
    component: PublicLayout,
    children: [
      {
        path: '',
        name: 'billingRenewal',
        meta: {
          title: 'Billing Renewal',
        },
        component: () => import('./views/billingRenewal'),
      },
    ],
  },

  // Redirect to 404
  {
    path: '*',
    redirect: 'system/404',
    hidden: true,
  },
];
const router = new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes,
});

const mappingRoute = {
  'billing-renewal': 'billingRenewal',
};

router.beforeEach((to, from, next) => {
  if (to.name === 'shareYourStory' || (to.name === 'captureVideo' && to.query.redirectTo === 'shareYourStory')) {
    store.dispatch('updateTheme', 'dark');
  } else {
    store.dispatch('updateTheme', 'light');
  }

  try {
    let locale = 'en';
    if (to.params.locale === 'es') {
      locale = 'es';
    } else if (to.params.locale === 'fr') {
      locale = 'fr';
    } else if (to.params.locale === 'ko') {
      locale = 'ko';
    }
    let nextRoute = {
      query: to.query,
    };

    if (store.state.settings.locale === 'es' && !startsWith(to.path, '/es')) {
      nextRoute = {
        ...nextRoute,
        params: {
          ...to.params,
          locale: 'es',
        },
      };
      return router.replace({ name: to.name, ...nextRoute });
    }
    if (store.state.settings.locale !== locale) {
      const setting = 'locale';
      store.commit('CHANGE_SETTING', { setting, value: locale });
    }
    if (!isEmpty(to.redirectedFrom)) {
      const redirectNameArr = to.redirectedFrom.match(/[\w-]+/);
      if (isArray(redirectNameArr)) {
        const tmpRouteName = redirectNameArr[0];
        return router.replace({ name: get(mappingRoute, tmpRouteName, tmpRouteName), ...nextRoute });
      }
    }
    if (to.matched.some(record => record.meta.isSystemPage || (record.meta.isParent && !record.meta.authRequired))) {
      return next();
    } else {
      if (to.matched.some(record => record.meta.isParent && record.meta.authRequired) && !store.state.user.user) {
        return next({
          name: 'signIn',
          ...nextRoute,
        });
      } else {
        const isAdmin = includes(store.state.user.user.role, 'admin');
        const isAdminRoute = to.matched.some(record => record.meta.isAdmin);
        if ((!isAdmin && isAdminRoute) || (isAdmin && !isAdminRoute)) {
          if (to.name === 'dashboard') {
            return next({
              name: 'AdminDashboard',
              ...nextRoute,
            });
          }
          return next({
            name: 'system404',
            ...nextRoute,
          });
        }
        if (store.state.user.needToPay) {
          const isNeededPay = get(to.matched, '[0].meta.payRequired', false);
          const routeRequired = get(to.matched, '[1].meta.payRequired', true);
          if (isNeededPay && routeRequired) {
            return next({
              name: 'system404',
              ...nextRoute,
            });
          }
        }
        if ((includes(to.name, 'dashboard') || includes(to.name, 'Dashboard')) && to.name !== store.getters.dashboardName) {
          next({
            name: store.getters.dashboardName,
            ...nextRoute,
          });
        } else if (to.path === '/') {
          next({
            path: 'dashboard',
            ...nextRoute,
          });
        } else {
          next({
            ...nextRoute,
          });
        }
      }
    }
  } catch (err) {
    console.error(err);
  }
});

export default router;
